<template>
  <!-- <transition name="modal" > -->
  <div id="modal-template">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <button class="modal-close-button" @click="$emit('close') & closeGA4Click()">X</button>
          <!-- <div class="modal-header">
            <slot name="header">
              default header
            </slot>
          </div>-->

          <div class="modal-body-body">
            <slot name="body">
              <TyCos v-if="wichModal === 'tycos'" name="millerlite" />
              <Politics v-if="wichModal === 'politics'" name="millerlite" />
            </slot>
          </div>

          <!-- <div class="modal-footer">
            <slot name="footer">
              default footer
              <button class="modal-default-button" @click="$emit('close')">
                OK
              </button>
            </slot>
          </div>-->
        </div>
      </div>
    </div>
  </div>
  <!-- </transition> -->
</template>

<script>
import TyCos from "@/components/TyCos";
import Politics from "@/components/Politics";
import tagFunctions from '@/utils/tagFunctions.js'

export default {
  name: "Modal",
  components: {
    TyCos,
    Politics
  },
  props: {
    wichModal: {
      type: String,
      default: "none"
    }
  },
  methods: {
    showModal(modal) {
      this.wichModal = modal;
      this.closeGA4Click();
    },
    closeGA4Click() {
      const valorModal = this.wichModal;
      //console.log(valorModal);
      if (valorModal == 'tycos') {
        tagFunctions.user_interactionPush('click', 'cerrar', 'popup terminos y condiciones')
      } else if (valorModal == 'politics') {
        tagFunctions.user_interactionPush('click', 'cerrar', 'popup aviso de privacidad')
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/modal.scss";
</style>
